export default __webpack_public_path__ + "static/media/pantry1-afterD.20ee4432.jpg";